<template>
  <div class="payment-account-requisites">
    <button @click.prevent="onClose"
            class="payment-account-requisites__close">
      <BaseSvg name="ico-close"/>
    </button>

    <h4 class="payment-account-requisites__title">Картка</h4>

    <dl class="payment-account-requisites__list">
      <dt v-if="number">Номер картки</dt>
      <dd v-if="number">{{ number?number:'' }}</dd>

      <dt v-if="expire">Дата закінчення терміну</dt>
      <dd v-if="expire">{{ expire?expire:'' }}</dd>

      <dt v-if="iban">IBAN</dt>
      <dd v-if="iban">{{ iban?iban:'' }}</dd>

      <dt v-if="mfo">МФО банку</dt>
      <dd v-if="mfo">{{ mfo?mfo:'' }}</dd>
    </dl>

    <div class="payment-account-requisites__footer">
      <button @click.prevent="onClose"
              class="payment-account-requisites__btn  base-btn  base-btn--outline-dark">
        Закрити
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PaymentAccountRequisites',
    props:{
      number: String,
      expire: String,
      mfo: String,
      iban: String
    },
    data() {
      return {}
    },
    methods: {
      onClose() {
        this.$vModal.close('payment-account-requisites')
      }
    }
  }
</script>

<style lang="less">

</style>
